import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

interface TypoboldProps {}

const Typobold: React.FC<TypoboldProps> = (props): JSX.Element => {
    const classes = useStyles();
    const { children } = props;

    return (
        <Typography variant="h6" component="h2" className={classes.sectionTitle}>
            {children}
        </Typography>
    );
};

//=====================================//
//=============== Style ===============//
//=====================================//

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        sectionTitle: {
            fontWeight: 'bold',
        },
    }),
);

export default Typobold;
